import { Injectable } from '@angular/core';
import { MetaData } from '@app/models/backend';

@Injectable({
  providedIn: 'root'
})
export class MetaDataService {

  metaData: MetaData | any = { 
    GetSD:null,
    GetSearchSD:null,
    GetUserSD:null,
    RegBusiness:null
  }

  constructor() { }
}
